/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SearchProductRequest;
(function (SearchProductRequest) {
    /**
     * specify if response should be returned as body or a file url. defaulted to BODY if not passed.
     */
    var responseType;
    (function (responseType) {
        responseType["BODY"] = "BODY";
        responseType["URL"] = "URL";
    })(responseType = SearchProductRequest.responseType || (SearchProductRequest.responseType = {}));
})(SearchProductRequest || (SearchProductRequest = {}));
